import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import {setCookie, getCookie} from "@/utils/cookieinfo.js"
import urlConfig from '@/api/urlConfig'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        isLogin: false,
        showRouterLink: false,
        showBanner: true,
        showdetailsid: '',
        token: null,
        userdef16: '',
        userInfo: null,
        showInfo: null,
        exh: '',
        steps: [],
        isFinish: false,
        lang: getCookie('lang') || ''
    },
    mutations: {
        SET_LOGININ(state, info) {
            state.userdef16 = info.userdef16
            state.token = info.token
            state.isFinish = info.isFinish
            state.showdetailsid = info.state
            state.exh = info.exh
        },
        SET_LANG(state, data) {
          state.lang = data
          setCookie('lang', data)
        }
    },
    actions: {
        loginIn({ commit }, info) {
            console.log(info);
            commit('SET_LOGININ', info);
        },
        goPage(store, options) {

        },
        setLang(store, data) {
          console.log(data)
          store.state.lang = data.lang
          store.commit('SET_LANG', data.lang)
        },
        getDetails(store, data) {
          return new Promise((resolve,reject) =>{
            Vue.prototype.$http({
              url: `${urlConfig.getShowdetailsidUrl}?showdetailsid=${data.showdetailsid}&exh=${data.exh}`,
              method: 'get'
            }).then(res => {
              if(res.data.successed) {
                var data = res.data.data
                store.commit('SET_LANG',data.languageID)
                resolve(data)
              }
            }).catch(err=>{
              reject(err)
            })
          })
        }
    },
    modules: {
        user
    }
});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js